import { useCallback, useState } from 'react';

/**
 * 모든 섹션의 접기/펼치기를 관리하는 훅.
 * 카운터 기반 트리거로 하위 `useInspectorSections`와 연동된다.
 */
export function useCollapseExpandAll() {
  const [isAllCollapsed, setIsAllCollapsed] = useState(false);
  const [collapseAllTrigger, setCollapseAllTrigger] = useState(0);
  const [expandAllTrigger, setExpandAllTrigger] = useState(0);

  const handleToggleAll = useCallback(() => {
    setIsAllCollapsed((prev) => {
      if (prev) {
        setExpandAllTrigger((t) => t + 1);
      } else {
        setCollapseAllTrigger((t) => t + 1);
      }
      return !prev;
    });
  }, []);

  return {
    isAllCollapsed,
    collapseAllTrigger,
    expandAllTrigger,
    handleToggleAll,
  } as const;
}
